import apiRequest from './apiRequest';
import type { MascotStatus } from './getMascot';

export type MascotEngine = 'scail' | 'kling';

export type MascotJobPayload = {
  inputVideoMediaID: string;
  characterReferenceMediaIDs: string[];
  prompt: string;
  environmentImageMediaID?: string;
  mascotName?: string;
  engine?: MascotEngine;
};

type CreateMascotBatchPayload = {
  batchName?: string;
  createdByUser?: string;
  emailSubscribers?: string[];
  jobs: MascotJobPayload[];
};

type CreateMascotResponse = {
  mascotID: string;
  mascotName?: string;
  status: MascotStatus;
  createdAt: string;
  createdBy: string;
  estimatedSecondsWaitTime?: number;
};

export default async function postMascot(
  payload: CreateMascotBatchPayload,
  apiKey: string,
) {
  return await apiRequest<CreateMascotResponse>(
    'external-mogen',
    '/mascot',
    {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
